// src/components/admin/AdminToolbar.js
import React, { useState } from 'react';

const AdminToolbar = ({
  collections,
  selectedCollection,
  onCollectionChange,
  onClearCollection,
  onDeleteSelected,
  selectedCount,
  availableFields,
  filterField,
  setFilterField,
  filterValue,
  setFilterValue,
  filterOperator,
  setFilterOperator,
  onApplyFilter,
  onResetFilter
}) => {
  const [showFilterControls, setShowFilterControls] = useState(false);

  return (
    <div className="w-full p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md mb-4">
      <div className="flex flex-col md:flex-row justify-between gap-4 mb-4">
        <div className="flex items-center">
          <label className="flex items-center gap-2 text-gray-700 dark:text-gray-200">
            Collection:
            <select 
              value={selectedCollection} 
              onChange={(e) => onCollectionChange(e.target.value)}
              className="p-2 rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              {collections.map((collection) => (
                <option key={collection} value={collection}>
                  {collection}
                </option>
              ))}
            </select>
          </label>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <button 
            className={`px-3 py-2 rounded text-white ${selectedCount === 0 ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600'} transition-colors`}
            disabled={selectedCount === 0}
            onClick={onDeleteSelected}
          >
            Delete Selected ({selectedCount})
          </button>
          <button 
            className="px-3 py-2 rounded bg-red-600 hover:bg-red-700 text-white transition-colors"
            onClick={onClearCollection}
          >
            Clear Collection
          </button>
          <button 
            className="px-3 py-2 rounded bg-blue-500 hover:bg-blue-600 text-white transition-colors"
            onClick={() => setShowFilterControls(!showFilterControls)}
          >
            {showFilterControls ? 'Hide Filters' : 'Show Filters'}
          </button>
        </div>
      </div>
      
      {showFilterControls && (
        <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg mt-2">
          <div className="flex flex-col md:flex-row gap-4 flex-wrap">
            <label className="flex flex-col gap-1 text-gray-700 dark:text-gray-200">
              Field:
              <select 
                value={filterField} 
                onChange={(e) => setFilterField(e.target.value)}
                className="p-2 rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Select Field</option>
                {availableFields.map((field) => (
                  <option key={field} value={field}>
                    {field}
                  </option>
                ))}
              </select>
            </label>
            
            <label className="flex flex-col gap-1 text-gray-700 dark:text-gray-200">
              Operator:
              <select 
                value={filterOperator} 
                onChange={(e) => setFilterOperator(e.target.value)}
                className="p-2 rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="==">Equals (==)</option>
                <option value="contains">Contains</option>
                <option value=">">Greater than (&gt;)</option>
                <option value="<">Less than (&lt;)</option>
              </select>
            </label>
            
            <label className="flex flex-col gap-1 text-gray-700 dark:text-gray-200">
              Value:
              <input 
                type="text" 
                value={filterValue} 
                onChange={(e) => setFilterValue(e.target.value)}
                placeholder="Enter value"
                className="p-2 rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </label>
            
            <div className="flex items-end gap-2">
              <button 
                className={`px-3 py-2 rounded text-white ${!filterField || !filterValue ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'} transition-colors`}
                onClick={onApplyFilter}
                disabled={!filterField || !filterValue}
              >
                Apply Filter
              </button>
              <button 
                className="px-3 py-2 rounded bg-gray-500 hover:bg-gray-600 text-white transition-colors"
                onClick={onResetFilter}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminToolbar;